import getEnv from '@sls-react/utils/getEnv';

export default function getBaseUrl(
  where?: 'secureVpc' | 'iam' | 'commerce' | 'rails',
) {
  switch (where) {
    case 'commerce':
      return getEnv('API_COMMERCE_URL');
    case 'iam':
      return getEnv('API_IAM_URL');
    case 'rails':
      return getEnv('API_RAILS_URL');
    case 'secureVpc':
      return getEnv('API_SECURE_URL');
  }

  return getEnv('API_RAILS_URL');
}
